import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

const USGS_GEO_URL = '/v2/integrations/device/usgs';

export const usgsGeoApi = createApi({
  reducerPath: 'usgsGeoApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  endpoints: (builder) => ({
    getEveryUSGSLocation: builder.query({
      query: () => ({
        url: `${USGS_GEO_URL}/map-locations`,
        method: 'GET',
      }),
      keepUnusedDataFor: 60 * 5, // Cache the data for 5 minutes (only starts when last subscriber unmounts and restarts if subscriber remounts)
    }),
  }),
});

export const { useGetEveryUSGSLocationQuery } = usgsGeoApi;
